(function (angular) {
    'use strict';

    angular.module('broadcast')
        /**
         *
         */
        .controller('ExistingBroadcastCtrl', ['$scope', '$rootScope', 'broadcasts', 'broadcastService', 'broadcastChannels', '$stateParams', 'jwtService', 'growlService', 'moment', '$state', 'utilService', 'broadcastSharedService', 'NgTableParams', '$filter',
            function ($scope, $rootScope, broadcasts, broadcastService, broadcastChannels, $stateParams, jwtService, growlService, moment, $state, utilService, broadcastSharedService, ngTableParams, $filter) {

                $scope.broadcasts = broadcasts;

                $scope.channels = Object.keys(broadcastChannels).reduce((obj, key) => {
                    if (broadcastChannels[key].allowed) {
                        obj[key] = broadcastChannels[key]
                    }
                    return obj;
                }, {});

                $scope.broadcastFilters = {};
                $scope.broadcastFilters.pickedChannels = Object.keys($scope.channels).map(function (key) { return $scope.channels[key]; });
                $scope.broadcastFilters.state = $stateParams.type || 'drafts';

                var sorting = $scope.broadcastFilters.state === 'drafts' ? {
                    _createdOn: 'desc'
                } : {
                    nextBroadcastOn: 'asc'
                }

                $scope.getUsername = broadcastSharedService.getUsername;
                $scope.viewDetails = broadcastSharedService.showBroadcastDetails;

                $scope.broadcastData = new ngTableParams({
                    page: 1,            // show first page
                    count: 10,           // count per page
                    sorting: sorting,
                    filter: $scope.broadcastFilters
                }, {
                    total: $scope.broadcasts.length, // length of data
                    getData: function ($defer, params) {
                        // use build-in angular filter
                        var orderedData = params.sorting() ? $filter('orderBy')($scope.broadcasts, params.orderBy()) : $scope.broadcasts;
                        var filter = params.filter();
                        var channels = filter.pickedChannels.map(function (channel) {
                            return channel.id;
                        });
                        orderedData = $filter('filter')(orderedData, function (value) {
                            return (!filter.name || value.name.includes(filter.name)) && channels.includes(value.rules[0]) && ((filter.state === 'drafts' && !value.schedule) || (filter.state !== 'drafts' && value.schedule));
                        });

                        $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                        params.total(orderedData.length);
                    },
                    filterDelay: 100
                });

                $scope.$watch('broadcastFilters.state', function (newVal, oldVal) {
                    if (newVal && newVal === "drafts") {
                        $scope.broadcastData.sorting("_createdOn", "desc");
                    } else if (newVal) {
                        $scope.broadcastData.sorting("nextBroadcastOn", "asc");
                    }
                })

                $scope.resend = function (broadcast) {

                    var newBroadcast = {
                        id: utilService.uuid(),
                        requireOptIn: broadcast.requireOptIn === true,
                        channelOptions: broadcast.channelOptions,
                        content: broadcast.content,
                        rules: broadcast.rules,
                        to: broadcast.to,
                        name: broadcast.name
                    }

                    // create new one
                    broadcastService.createBroadcast($stateParams.pickedApiSpaceId, newBroadcast)
                        .then(function (result) {
                            // go to wizard ...
                            $state.go("main.apiSpace.broadcastWizard", {
                                broadcastId: newBroadcast.id
                            });
                        });
                };

                $scope.nextBroadcast = function (schedule) {
                    var now = moment();
                    if (schedule && schedule.recurring) {
                        var startOn = moment(schedule.recurring.startOn);
                        var endOn = moment(schedule.recurring.endOn);
                        var diff;
                        if (endOn < now) {
                            return "Finished";
                        }
                        switch (schedule.recurring.frequency) {
                            case 'hour':
                                startOn.add(schedule.recurring.minutes[0], 'minutes');
                                diff = now.diff(startOn, 'hours');
                                if (diff >= 0) {
                                    startOn.add(Math.floor(diff), 'hours');
                                    if (startOn <= now) {
                                        startOn.add(schedule.recurring.interval, 'hours');
                                    }
                                }
                                break;
                            case 'day':
                                var hour = schedule.recurring.times[0].split(':');
                                startOn.set({ hour: hour[0], minute: hour[1] });
                                diff = now.diff(startOn, 'days');
                                if (diff >= 0) {
                                    startOn.add(Math.floor(diff), 'days');
                                    if (startOn <= now) {
                                        startOn.add(schedule.recurring.interval, 'days');
                                    }
                                }
                                break;
                            case 'week':
                                var hour = schedule.recurring.times[0].split(':');
                                var day = schedule.recurring.daysOfWeek[0];
                                startOn.set({ hour: hour[0], minute: hour[1] });
                                startOn.isoWeekday(day);
                                diff = now.diff(startOn, 'weeks');
                                if (diff >= 0) {
                                    startOn.add(Math.floor(diff), 'weeks');
                                    if (startOn <= now) {
                                        startOn.add(schedule.recurring.interval, 'weeks');
                                    }
                                }
                                break;
                            case 'month':
                                var hour = schedule.recurring.times[0].split(':');
                                var day = schedule.recurring.daysOfMonth[0];
                                startOn.set({ hour: hour[0], minute: hour[1] });
                                if (day == "L") {
                                    startOn.endOf("Month");
                                }
                                else {
                                    startOn.date(day);
                                }

                                diff = now.diff(startOn, 'months');
                                if (diff >= 0) {
                                    startOn.add(Math.floor(diff), 'months');
                                    if (startOn <= now) {
                                        startOn.add(schedule.recurring.interval, 'months');
                                    }
                                }
                                break;

                        }
                        return startOn;
                    }
                    else if (schedule && schedule.once) {

                        if (moment(schedule.once.startOn) < now) {
                            return "Finished";
                        }
                        return moment(schedule.once.startOn);
                    }
                    return '';
                };

                //adding nextBroadcastOn for every scheduled broadcast - needed to sorting
                //we need this in display version and actual value to sorting
                $scope.broadcasts.forEach(function (singleBroadcast, broadcastIndex) {
                    if (singleBroadcast.schedule) {
                        var nextBroadcast = $scope.nextBroadcast(singleBroadcast.schedule);
                        $scope.broadcasts[broadcastIndex].nextBroadcastOn = moment.isMoment(nextBroadcast) ? nextBroadcast.toDate() : nextBroadcast;
                        $scope.broadcasts[broadcastIndex].nextBroadcastOnDisplay = moment.isMoment(nextBroadcast) ? nextBroadcast.format("DD.MM.YYYY HH:mm") : nextBroadcast;

                        var timezone = singleBroadcast.schedule.recurring ? singleBroadcast.schedule.recurring.timezone : (singleBroadcast.schedule.once ? singleBroadcast.schedule.once.timezone : undefined);
                        if (timezone) {
                            $scope.broadcasts[broadcastIndex].nextTimezoneBroadcastOn = moment.isMoment(nextBroadcast) ? nextBroadcast.tz(timezone).toDate() : nextBroadcast;
                            $scope.broadcasts[broadcastIndex].nextTimezoneBroadcastOnDisplay = moment.isMoment(nextBroadcast) ? nextBroadcast.tz(timezone).format("DD.MM.YYYY HH:mm") : nextBroadcast;
                            $scope.broadcasts[broadcastIndex].timezone = timezone;
                        } else {
                            $scope.broadcasts[broadcastIndex].nextTimezoneBroadcastOn = $scope.broadcasts[broadcastIndex].nextBroadcastOn
                            $scope.broadcasts[broadcastIndex].nextTimezoneBroadcastOnDisplay = $scope.broadcasts[broadcastIndex].nextBroadcastOnDisplay

                        }
                    }
                });


                $scope.getBroadcastPopover = function getBroadcastPopover(broadcast) {
                    if (broadcast.sendId) {
                        return '<b>Broadcast id:</b> ' + broadcast.broadcast.id + '<br><b>Send id:</b> ' + broadcast.sendId;
                    }
                    else {
                        return '<b>Broadcast id:</b> ' + broadcast.id;
                    }
                };

                $scope.getTimezoneDetails = function (broadcast) {
                    return '<b>Timezone: </b>' + broadcast.timezone + '<br><b>Local Time: </b>' + broadcast.nextTimezoneBroadcastOnDisplay;
                }

                $scope.exportData = function (broadcastId, sendId) {
                    $rootScope.$broadcast('fileDownload', { url: "/apispaces/" + $stateParams.pickedApiSpaceId + "/broadcasts/" + broadcastId + "/history/" + sendId + "/export?includeHeaders=true", token: jwtService.token, fileName: "broadcastExport.csv", httpVerb: "GET", acceptHeaders: "application/csv" });
                };

                $scope.deleteScheduledBroadcast = function (broadcast) {
                    broadcastService.deleteScheduledBroadcast($stateParams.pickedApiSpaceId, broadcast.id).then(function (result) {
                        broadcast.status = "draft";
                        $scope.broadcastData.reload();
                        growlService.success("Broadcast successfully unscheduled");
                    }).catch(function (error) {
                        growlService.danger("Broadcast wasn't unscheduled due to: " + error.statusText);
                    });
                };

                $scope.deleteBroadcast = function (broadcast) {
                    broadcastService.deleteBroadcast($stateParams.pickedApiSpaceId, broadcast.id).then(function (result) {
                        $scope.broadcasts.splice($scope.broadcasts.indexOf(broadcast), 1);
                        $scope.broadcastData.reload();
                        growlService.success("Broadcast successfully deleted");
                    }).catch(function (error) {
                        growlService.danger("Broadcast wasn't deleted due to: " + error.statusText);
                    });
                };

                $scope.reRunScheduledBroadcast = function (broadcast) {
                    return broadcastService.scheduleBroadcast($stateParams.pickedApiSpaceId, broadcast.id, broadcast.schedule).then(function (result) {
                        broadcast.status = "scheduled";
                        return true;
                    }).catch(function (result) {
                        growlService.danger("There was a problem with scheduling broadcast, try again");
                        return false;
                    });
                }
            }]);

})(window.angular);